export default "__VITE_ASSET__wbYh9apn__"